import { DistributePurchaseInvoiceRowsReq } from '../../../common/application/model/api/DistributePurchaseInvoiceRowsReq';
import { DistributePurchaseInvoiceRowsResp } from '../../../common/application/model/api/DistributePurchaseInvoiceRowsResp';
import { requestService } from '../../framework/client/query_client';
import { HttpMethod } from '../../../common/framework/model/HttpMethod';
import { ApplicationServiceType } from '../../../common/application/enumeration/ApplicationServiceType';

export async function postDistributePurchaseInvoiceRows(
    parameters: DistributePurchaseInvoiceRowsReq,
): Promise<DistributePurchaseInvoiceRowsResp> {
    return (await requestService<undefined, DistributePurchaseInvoiceRowsReq, DistributePurchaseInvoiceRowsResp>(
        {
            method: HttpMethod.POST,
            type: ApplicationServiceType.PURCHASE_INVOICE_ROWS_DISTRIBUTE,
        },
        undefined,
        parameters,
    ))!;
}
